import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { BusinessDataState } from '../interfaces/appInterface'

const initialState: BusinessDataState = {
  businessData: null,
  businessId: null
}

const businessDataSlice = createSlice({
  name: 'businessData',
  initialState,
  reducers: {
    resetState: () => initialState,
    setBusinessData(state: BusinessDataState, action: PayloadAction<any>) {
      state.businessData = action.payload
      state.businessId = action.payload.id
    }
  }
})

export const { setBusinessData, resetState } = businessDataSlice.actions
export default businessDataSlice.reducer
